export const deleteLocationsApiErrors: Record<string, string> = {
  UNABLE_TO_DELETE_LOCATION: 'unableToDeleteLocation',
};
